import styles from "./BottomAside.module.css";

/**
 * BottomAside Component
 * ---------------------
 * This component displays a small information bar (fixed at the bottom
 * of a photographer's page) showing:
 *  - The total number of likes across the photographer's media.
 *  - The photographer's daily price rate.
 *
 * Props:
 *  - likes (number): total number of likes.
 *  - price (number): daily price in euros.
 */
export default function BottomAside({ likes, price }) {
  return (
    <aside className={styles.sideInfos}>
      {/* Display the number of likes with a heart icon */}
      <div className={styles.mediaLikes}>
        <p>{likes}</p>

        {/* Heart SVG icon (represents likes) */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className={styles.heartIcon}
        >
          <path d="M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C139.9 410.2 0 279.9 0 167.7l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1z" />
        </svg>
      </div>

      {/* Display the photographer’s daily price */}
      <p>{price + "€/jour"}</p>
    </aside>
  );
}
